import { render } from "./Pledge.vue?vue&type=template&id=2d42db7e"
import script from "./Pledge.vue?vue&type=script&lang=js"
export * from "./Pledge.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__